__turbopack_context__.v({
  "className": "te9J1a_className",
  "variable": "te9J1a_variable",
});
